<template>
  <div>
    <el-dialog :visible.sync="visible"
               :close-on-click-modal='false'
               :before-close="cancelAdd"
               title="线下支付"
               width="800px">
      <div class="pay-dialog-body">
        <div class="pay-info">本次待支付订单金额：<p class="pay-money">{{payMoney}}</p>元</div>
        <div class="pay-info">请打款至以下收款账户：</div>
        <el-card class="pay-card">
          <div class="pay-card-info-header">账户名称：<span class="pay-card-info-import">{{accountCustomerName}}</span></div>
          <div class="pay-card-info-header">账号：<span class="pay-card-info-import">{{virtualno}}</span><span class="pay-card-account-tip">(注：该账号只适用于本订单付款)</span></div>
          <div class="pay-card-info">收款银行：
            <span class="pay-card-info-value">支付机构备付金集中存管账户</span>
            <el-tooltip>
              <div slot="content"
                   style="width:500px;">支付机构备付金集中存管账户，等同于开户银行名称。全国持牌第三方支付机构统一存放的备付金账户开立在人民银行，用于接收、存放客户资金的专门账户，受人民银行监管。
              </div>
              <i class="el-icon-question"
                 style="color: #1D65A8;"></i>
            </el-tooltip>
            <!-- <i class="el-icon-question" style="color: #1D65A8;" title=""></i> -->
          </div>
          <div class="pay-card-info">省：<span class="pay-card-info-value">浙江省&nbsp;&nbsp;</span>市：<span class="pay-card-info-value">杭州市</span></div>
          <div class="pay-card-info">开户支行及行号：<span class="pay-card-info-value">连连银通-备付金账户&nbsp;&nbsp;991331000295</span>
          </div>
          <div class="pay-download"
               @click="download()">各大银行操作指南</div>
        </el-card>
        <div class="pay-dialog-tip">
          <span class="pay-tip-title">温馨提示：</span>
          <div class="pay-tip-content">
            <ol style="margin-left:25px; list-style-type:decimal">
              <li style="list-style-type:decimal">转账实时到账，但以下时间不支持转账：<br>工作日：17:15-20:30不支持; 节假日：不支持</li>
              <li style="list-style-type:decimal">
                如您付款异常，退款情况如下：
                <ol style="margin-left:25px;list-style-type:lower-roman">
                  <li style="list-style-type:lower-roman">在工作日时间内支付，退款将在30分钟内完成</li>
                  <li style="list-style-type:lower-roman">在非工作日时间内支付，退款将在下一个工作日的9点30分之前完成<br>
                  </li>
                </ol>
                如超时未收到退款，请拨打连连支付客服电话：400-0188-888
              </li>
              <!-- <li style="list-style-type:decimal">尊敬的用户您好，该订单默认为企业采购订单，支付过程中，如果您使用个人支付宝或个人网银为本订单支付时，您须确认使用的是您本人的个人账号，同时确认该笔支付已获得本订单企业的授权。</li> -->
            </ol>
            <div></div>
          </div>
          <!-- <span class="pay-download" @click="download()">各大银行操作指南</span> -->
        </div>
      </div>
      <div class="pay-dialog-footer">
        <div class="pay-dialog-other"
             @click="cancelAdd()"><i class="el-icon-arrow-left"
             style="padding-right:10px;"></i>选择其他方式支付</div>
        <div class="pay-dialog-button"
             @click="handlePay()">确认，去线下支付</div>
      </div>

      <!-- <div class="pay-dialog-body">
        <div class="pay-info">本次待支付订单金额：<p class="pay-money">{{payMoney}}</p>元</div>
        <div class="pay-info">请打款至以下任一收款账户：</div>
        <el-card class="pay-card">
          <div class="pay-card-info-header">账户名称：<span class="pay-card-info-import">中控技术股份有限公司</span></div>
          <div class="pay-card-info-header">账号：<span class="pay-card-info-import">1202021419900065818</span>
          </div>
          <div class="pay-card-info">收款银行：<span class="pay-card-info-value">工行钱江支行</span>
          </div>
        </el-card>
        <el-card class="pay-card">
          <div class="pay-card-info-header">账户名称：<span class="pay-card-info-import">浙江工自仪网络有限公司</span></div>
          <div class="pay-card-info-header">账号：<span class="pay-card-info-import">1202023419100041747</span></div>
          <div class="pay-card-info">收款银行：<span class="pay-card-info-value">工行杭州景江苑支行</span></div>
        </el-card>
      </div>
      <div class="pay-dialog-footer">
        <div class="pay-dialog-other" @click="cancelAdd()"><i class="el-icon-arrow-left" style="padding-right:10px;"></i>选择其他方式支付</div>
        <div class="pay-dialog-button" @click="handlePay()">确认，去线下支付</div>
      </div> -->
      <!-- <el-form :model="dataForm" :inline="true" ref="dataForm"  label-width="160px" class="demo-form-inline">
        <el-row >
        <el-col :span="24">
          <el-form-item label="收款账号：" prop="userName">
            {{virtualno}}<span class="card-gray">(该账号仅限当前订单使用)</span>
          </el-form-item>
        sheng</el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="收款方名称：" prop="userName">
            中控技术股份有限公司
            {{accountCustomerName}}
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="开户银行：" prop="userName">
            支付机构备付金集中存管账户
          </el-form-item>
        </el-col>
      </el-row>
      <el-row >
        <el-col :span="24">
          <el-form-item label="开户行名：" prop="userName">
            连连银通-备付金账户
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="开户行号：" prop="userName">
            991331000295
          </el-form-item>
        </el-col>
      </el-row>
      <div class="btns">
          <el-button type="primary" class="btn-check" :class="subLoading?'but-loading':''" @click="handlePay">返回订单详情页</el-button>      </div>
    </el-form> -->
      <!-- <div class="btns">
      <el-button type="primary" class="btn-check" :class="subLoading?'but-loading':''" @click="handlePay">返回订单详情页</el-button>
    </div>
    <div class="other-pay" @click="cancelAdd()"><img src="/static/img/pay/arrow.png" class="back-arrow"/>选择其他支付方式</div> -->
    </el-dialog>
    <div class="container-pay">
      <!-- 面包屑 -->
      <!-- <div class="integralBreadcrumb">
        <div class="integralBreadcrumb-item"
             @click="routerHandle('basicInfo')">个人中心</div>
        <div class="el-icon-arrow-right jt"></div>
        <div class="integralBreadcrumb-item"
             @click="routerHandle()">我的对账单</div>
        <div class="el-icon-arrow-right jt"></div>
        <div class="integralBreadcrumb-item"
             @click="routerHandle()">订单支付</div>
      </div> -->
      <div class="body-info">
        <el-form :model="dataForm"
                 :inline="true"
                 ref="dataForm"
                 label-width="160px"
                 class="demo-form-inline">
          <el-row>
            <el-col :span="12">
              <el-form-item label=""
                            prop="userCompany">
                <label>订单提交成功，请您尽快付款</label>
              </el-form-item>
            </el-col>
            <el-col :span="12"
                    style="text-align:center">
              <el-form-item label="支付金额："
                            prop="userCompany">
                <label><span class="money">{{payMoney}}</span>元</label>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-row>
        <el-col :span="12">
          <el-form-item label="" prop="userCompany">
            <label>订单已提交成功，请您尽快付款</label>
          </el-form-item>
        </el-col>
      </el-row> -->
          <div class="payType">
            <el-row style="border-bottom:1px solid #f7f7f7;padding:20px;">
              <el-col>
                <el-radio v-model="dataForm.check"
                          label="EBANK_DEBIT_CARD">
                  <img src="../../../../assets/img/pay/card1.png" /><span class="cardImg">网银借记卡</span>
                </el-radio>
              </el-col>
            </el-row>
            <el-row style="border-bottom:1px solid #f7f7f7;padding:20px;">
              <el-col>
                <el-radio v-model="dataForm.check"
                          label="EBANK_CREDIT_CARD">
                  <img src="../../../../assets/img/pay/card4.png" /><span class="cardImg">网银信用卡</span>
                </el-radio>
              </el-col>
            </el-row>
            <el-row style="border-bottom:1px solid #f7f7f7;padding:20px;">
              <el-col>
                <el-radio v-model="dataForm.check"
                          label="EBANK_B2B">
                  <img src="../../../../assets/img/pay/card2.png" /><span class="cardImg">企业网银</span>
                </el-radio>
              </el-col>
            </el-row>
            <!-- <el-row style="border-bottom:1px solid #f7f7f7;padding:20px;">
          <el-col>
            <el-radio v-model="dataForm.check" label="EBANK_CREDIT_CARD">
                <img src="/static/img/pay/card4.png"/><span class="cardImg">个人信用卡</span>
            </el-radio>
          </el-col>
      </el-row> -->
            <!-- <el-row style="border-bottom:1px solid #f7f7f7;padding:20px;">
          <el-col>
            <el-radio v-model="dataForm.check" label="EBANK_B2B">
                <img src="/static/img/pay/card2.png"/><span class="cardImg">网银支付</span>
            </el-radio>
          </el-col>
      </el-row> -->
            <el-row style="border-bottom:1px solid #f7f7f7;padding:20px;">
              <el-col>
                <el-radio v-model="dataForm.check"
                          label="60">
                  <img src="../../../../assets/img/pay/card3.png" /><span class="cardImg">线下支付</span>
                </el-radio>
              </el-col>
            </el-row>
            <!-- <el-row style="border-bottom:1px solid #f7f7f7;padding:20px;">
          <el-col>
            <el-radio v-model="dataForm.check" label="10">
                <img src="/static/img/pay/zhifubao.png"/><span class="cardImg">支付宝</span>
            </el-radio>
          </el-col>
      </el-row>
      <el-row style="border-bottom:1px solid #f7f7f7;padding:20px;">
          <el-col>
            <el-radio v-model="dataForm.check" label="20">
                <img src="/static/img/pay/wechat.png"/><span class="cardImg">微信支付</span>
            </el-radio>
          </el-col>
      </el-row> -->
          </div>
          <div class="pay-dialog-tip">
            <span class="pay-tip-title">温馨提示：</span>
            <div class="pay-tip-content">
              <ol style="margin-left:25px;">
                <li>尊敬的用户您好，该订单默认为企业采购订单，支付过程中，如果您使用个人支付宝或个人网银为本订单支付时，您须确认使用的是您本人的个人账号，同时确认该笔支付已获得本订单企业的授权。</li>
              </ol>
              <div></div>
            </div>
            <!-- <span class="pay-download" @click="download()">各大银行操作指南</span> -->
          </div>
          <div class="row"
               style="display:flex;justify-content: center;margin-top:20px">
            <div :class="'row-opt-but '"
                 style="background-color:#1D65A8;color:#fff"
                 @click="handleSave()">
              立即支付
            </div>
          </div>
        </el-form>
        <span slot="footer"
              class="dialog-footer">
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dataForm: {
        check: '30'
      },
      visible: false,
      subLoading: false,
      virtualno: '',
      accountCustomerName: ''
    }
  },
  mounted () {
    // console.log(sessionStorage.getItem('billId'))
  },
  computed: {
    payMoney () {
      return this.$route.params.money
        ? this.$route.params.money
        : sessionStorage.getItem('pay')
    }
  },
  methods: {
    // 下载各大银行操作指南
    download () {
      // id：41147
      // softWare/1593678411154/中控线下转账支付说明.pptx
      // id: 43065
      // softWare/1594890067630/中控线下转账支付说明.pptx
      window.open(
        'https://plantmate-privacy-prod.oss-cn-hangzhou.aliyuncs.com/software/%E4%B8%AD%E6%8E%A7%E7%BA%BF%E4%B8%8B%E8%BD%AC%E8%B4%A6%E6%94%AF%E4%BB%98%E8%AF%B4%E6%98%8E.pptx'
      )
    },
    // 跳转页面,取消返回
    routerHandle (name, pName) {
      if (name) {
        this.$router.push({ name: name })
      } else {
        this.$router.go(-1)
      }
    },
    cancelAdd () {
      this.visible = false
    },
    handleSave () {
      if (this.dataForm.check === '60') {
        // 线下支付
        this.handleCard()
        this.visible = true
      } else {
        this.$http
          .post(
            `/front/payment/lianlian/lclbGenerateOrderPayInfo`,
            {
              billId: this.$route.params.id ? this.$route.params.id : sessionStorage.getItem('billId'),
              payeeMemo: '',
              paymentType: this.dataForm.check
            }
          )
          .then(({ data: res }) => {
            if (res.code === 0) {
              let url = res.data.gatewayUrl
              this.handleOPenUrl(url)
            }
          })
      }
    },
    handleOPenUrl (url) {
      var tempForm = document.createElement('form')
      tempForm.action = url
      // tempForm.target = '_blank'
      tempForm.method = 'post'
      tempForm.style.display = 'none'
      document.body.appendChild(tempForm)
      tempForm.submit()
      document.body.removeChild(tempForm)
    },
    // 确认线下支付
    handlePay () {
      this.$router.push({
        name: 'spareStatementDetail',
        query: {
          id: this.$route.params.id ? this.$route.params.id : sessionStorage.getItem('billId')
        }
      })
    },
    // 生成虚拟卡号
    handleCard () {
      this.$http
        .post(
          `/front/payment/lianlian/lclbGetFictitiousCardInfo`,
          {
            billId: this.$route.params.id ? this.$route.params.id : sessionStorage.getItem('billId')
          }
        )
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.virtualno = res.data.virtualno
            this.accountCustomerName = res.data.accountCustomerName
          } else {
            this.virtualno = res.data.virtualAccount
            this.accountCustomerName = res.data.accountCustomerName
          }
        })
    }
  }
}
</script>
<style scoped lang="scss">
.pay-dialog-body {
  padding: 0 90px 10px;
  .pay-info {
    font-size: 16px;
    line-height: 32px;
    .pay-money {
      font-size: 26px;
      display: inline-block;
      color: #333;
      padding-left: 10px;
    }
  }
  .pay-card {
    margin-top: 10px;
    // padding: 20px;
    min-width: 500px;
    // background-color: #F8F8F8 100%;
    background: #f8f8f8;
    color: #666;
    .pay-card-info-header {
      font-size: 18px;
      line-height: 40px;
      .pay-card-info-import {
        color: #151515;
      }
      .pay-card-account-tip {
        font-size: 14px;
        color: #e52020;
        padding-left: 10px;
      }
    }
    .pay-card-info {
      font-size: 16px;
      line-height: 40px;
      .pay-card-info-value {
        color: #151515;
      }
    }
    .pay-download {
      cursor: pointer;
      margin-left: 30px;
      // width: 180px;
      color: #1d65a8;
      text-align: right;
      text-decoration: underline;
    }
  }
  .pay-dialog-tip {
    display: flex;
    margin-top: 10px;
    justify-content: space-between;
    // align-items: center;
    font-size: 14px;
    line-height: 26px;
    .pay-tip-title {
      flex-shrink: 0;
      width: 80px;
    }
    .pay-tip-content {
      flex-grow: 1;
      color: #ff9238;
    }
  }
}
.container-pay {
  width: 1190px;
  margin: 0 auto;
  .pay-dialog-tip {
    display: flex;
    margin-top: 10px;
    justify-content: space-between;
    // align-items: center;
    font-size: 14px;
    line-height: 26px;
    .pay-tip-title {
      flex-shrink: 0;
      width: 80px;
    }
    .pay-tip-content {
      flex-grow: 1;
      color: #ff9238;
    }
  }
}
.pay-dialog-footer {
  margin-top: 20px;
  margin-right: 90px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .pay-dialog-other {
    cursor: pointer;
    color: #1d65a8;
    font-size: 14px;
  }
  .pay-dialog-button {
    cursor: pointer;
    color: #fff;
    font-size: 16px;
    background: #1d65a8;
    padding: 10px 30px;
  }
}

/deep/ .el-input.is-disabled .el-input__inner {
  color: #000;
}
/deep/ .el-textarea.is-disabled .el-textarea__inner {
  color: #000;
}
.payType {
  padding: 20px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 8px;
}
.cardImg {
  margin-left: 10px;
  color: #000;
  font-size: 16px;
}
.card-gray {
  color: #aeaeae;
  margin-left: 10px;
}
.back-arrow {
  margin-right: 10px;
}
.other-pay {
  color: #1d65a8;
  margin-top: 50px;
  cursor: pointer;
}
.body-info h2 {
  font-size: 20px;
  color: #262626;
  margin-bottom: 20px;
}
.body-info {
  margin: 20px 0;
  width: 100%;
  padding: 30px 100px;
  background-color: #fff;
  word-wrap: break-word;
  word-break: break-all;
}
.row-opt-but {
  width: 161px;
  height: 50px;
  border: 1px solid #1d65a8;
  background-color: #fff;
  color: #1d65a8;
  font-size: 16px;
  line-height: 48px;
  text-align: center;
  cursor: pointer;
}
.row-opt-but:hover {
  background-color: #1d65a8;
  color: #fff;
}
.but-loading {
  opacity: 0.5;
  cursor: not-allowed;
}
.btns {
  margin-left: 80px;
}
.btn-check {
  margin-right: 30px;
  background-color: #1d65a8;
  border-color: #1d65a8;
}
.addressList {
  list-style: none;
}
.two-btns {
  margin-bottom: 10px;
}
.addFunc {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
.addCancel {
  width: 158px;
  height: 48px;
  line-height: 48px;
  text-align: center;
  color: #1d65a8;
  border: 1px solid #1d65a8;
  margin-right: 10px;
  user-select: none;
  cursor: pointer;
}
.spareInfo {
  line-height: 24px;
  font-size: 18px;
  color: #303133;
  font-weight: normal;
  margin-bottom: 20px;
  margin-top: 10px;
}
.inquiryfj {
  padding-left: 8px;
  display: flex;
  flex-wrap: wrap;
}
.inquiryfj li {
  padding-left: 5px;
  width: 100px;
  position: relative;
}
.inquiryfjx {
  position: absolute;
  right: 0px;
  top: 0;
  width: 20px;
  height: 20px;
}
.inquiryfj li img {
  width: 95px;
  height: 95px;
  cursor: pointer;
}
.inquiryfj li p {
  text-align: center;
  font-size: 14px;
  line-height: 20px;
  color: #333333;
  font-weight: bold;
}
.inqueryDetail {
  .el-textarea {
    width: 100%;
    min-width: 500px;
  }
  .good-link {
    cursor: pointer;
    color: #1d65a8;
    text-decoration: underline;
  }
  /deep/ .el-form-item__label {
    flex-grow: 0;
    flex-shrink: 0;
  }
  /deep/ .el-form--inline .el-form-item,
  .el-form--inline .el-form-item__content {
    display: flex;
    word-break: break-all;
    word-wrap: break-word;
  }
}
.money {
  color: #f00;
  margin-right: 10px;
}
</style>
